import MastheadSection from './components/MastheadSection';
import EngineeringOverviewSection from './components/EngineeringOverviewSection';
import ServicesGridSection from './components/ServicesGridSection';
import CoreValuesSection from './components/CoreValuesSection';
import PhilosophySection from './components/PhilosophySection';
import ContactFooterSection from './components/ContactFooterSection';

export default function Home() {
  return (
    <main className="w-full min-w-[1024px] overflow-x-auto">
      <MastheadSection />
      <EngineeringOverviewSection />
      <ServicesGridSection />
      <CoreValuesSection />
      <PhilosophySection />
      <ContactFooterSection />
    </main>
  );
}